<script lang="ts">
	import DecoratedHeadline from "../../../shared/components/DecoratedHeadline.svelte";
	import Layout from "../components/Layout.svelte";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./CareerDetail.translations.json";
	import type { CareerDetailProps } from "./CareerDetailProps.js";
	import Button from "../../../shared/components/Button.svelte";
	import Modal from "../../../shared/components/Modal.svelte";
	import CareerForm from "../../../shared/components/Career/CareerForm.svelte";
	import { nbspify } from "../../../../core/utils/nbspify.js";
	import Content from "../../../shared/components/Content.svelte";
	import Breadcrumbs from "../../../shared/components/Breadcrumbs.svelte";
	import arrowRightLong from "../../../../core/assets/icons/arrow-right-long.svg?raw";
	import CareerDesktopGallery from "../../../shared/components/Career/CareerDesktopGallery.svelte";
	import CareerMobileGallery from "../../../shared/components/Career/CareerMobileGallery.svelte";
	import { thumbnailImageContextKey } from "../contexts/thumbnailImageContextKey.js";
	import { getGlobalSettings } from "../getGlobalSettings.js";
	import { getContext, setContext } from "svelte";
	import type { GlobalTemplateProps } from "../GlobalTemplateProps.js";
	import { pageSlugContextKey } from "../contexts/pageSlugContextKey.js";
	import { VertiType } from "../../../../core/schema/VertiType.js";

	type $$Props = CareerDetailProps;

	const { position, breadcrumbs } = $$restProps as $$Props;
	const { STORAGE_URL, TENANT_LOCALE } = getGlobalSettings();
	const pageSlug = getContext<GlobalTemplateProps["pageSlug"]>(pageSlugContextKey);

	const translate = getTranslate(translations);

	let showCareerModal = false;

	function openCareerModal(): void {
		showCareerModal = true;
	}

	$: [primaryImage] = position.images;
	setContext(thumbnailImageContextKey, primaryImage ? `${STORAGE_URL}/${primaryImage.path}` : undefined);
</script>

<Modal bind:show={showCareerModal} class="!bg-gray lg:w-[46.25rem]">
	<CareerForm vertiType={VertiType.Flex} {position} on:close={() => (showCareerModal = false)} />
</Modal>

<Layout>
	<div class="container flex flex-col md:items-center">
		<Breadcrumbs pageSlug={pageSlug[TENANT_LOCALE] ?? ""} {breadcrumbs} />
		<section>
			<div class="lg:w-[50rem]">
				<DecoratedHeadline class="!pl-0 !text-left">{nbspify(position.name)}</DecoratedHeadline>
				<h2 class="text-md font-normal lg:text-[1.5rem] lg:leading-8">{nbspify(position.perex)}</h2>
			</div>
			<div class="lg:w-[50rem]">
				<Content content={position.content} />
			</div>
			<Button on:click={openCareerModal} variant="primary" icon={arrowRightLong}>
				{translate("getInTouch")}
			</Button>
		</section>
		{#if position.images}
			<section class="hidden md:block lg:w-[57.5rem]">
				<CareerDesktopGallery {position} images={position.images} />
			</section>
			<section class="md:hidden">
				<CareerMobileGallery class="md:hidden" {position} images={position.images} />
			</section>
		{/if}
	</div>
</Layout>
